module.exports = __webpack_public_path__ + "img/curved11.0bd5b3f5.jpg";